import React from 'react';
import Modal from './modal';
import { ModalHeader, ModalBody } from './containers';
import { ModalBodyWrapper} from './../common/wrappers'


const PaymentModal = () => (
  <Modal>
    <ModalHeader />
    <ModalBodyWrapper>
      <ModalBody />
    </ModalBodyWrapper>
  </Modal>
)

export default PaymentModal;
